import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Button, Dropdown, Header, Icon, Input, List, Loader, Table} from 'semantic-ui-react';

import {
    addParticipant,
    cancelParticipant,
    clearErrors,
    deleteParticipant,
    displayValidationErrors,
    editParticipant,
    getParticipants,
    saveParticipant,
    updateParticipantBirthDate,
    updateParticipantFirstName,
    updateParticipantGender,
    updateParticipantLastName
} from "../../actions/participants";
import TextField from "../common/TextField";
import ErrorModal from "../common/ErrorModal";

class Participants extends Component {

    componentDidMount() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        } else {
            this.props.dispatch(getParticipants());
        }
    }

    componentDidUpdate() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        }
    }

    onClickAdd(e) {
        this.props.dispatch(addParticipant({id: 0, firstName: "", lastName: "", birthDate: "", gender: "MALE"}));
    }

    onClickRefresh(e) {
        this.props.dispatch(getParticipants());
    }

    onClickEdit(e, participant, index) {
        this.props.dispatch(editParticipant(participant, index));
    }

    onClickSave(e) {
        if (this.props.participantFirstNameErrors.length > 0
            || this.props.participantLastNameErrors.length > 0
            || this.props.participantBirthDateErrors.length > 0) {
            this.props.dispatch(displayValidationErrors());
        } else {
            this.props.dispatch(saveParticipant({
                id: this.props.participantId,
                firstName: this.props.participantFirstName,
                lastName: this.props.participantLastName,
                birthDate: this.props.participantBirthDate,
                gender: this.props.participantGender
            }));
        }
    }

    onClickCancel(e) {
        this.props.dispatch(cancelParticipant());
    }

    onClickDelete(e, participant) {
        this.props.dispatch(deleteParticipant(participant));
    }

    onChangeFirstName(e) {
        this.props.dispatch(updateParticipantFirstName(e.target.value));
    }

    onChangeLastName(e) {
        this.props.dispatch(updateParticipantLastName(e.target.value));
    }

    onChangeBirthDate(e) {
        this.props.dispatch(updateParticipantBirthDate(e.target.value));
    }

    onChangeGender(e, data) {
        this.props.dispatch(updateParticipantGender(data.value));
    }

    onClickAddParticipant(e, participant) {

    }

    onClickRemoveParticipant(e, participant) {

    }

    onCloseErrorModal(e) {
        this.props.dispatch(clearErrors());
    }

    render() {
        return (
            <div style={{margin: "1rem 0"}}>
                <ErrorModal open={this.props.savingParticipantFailed}
                            onClose={(e) => {
                                this.onCloseErrorModal(e)
                            }}
                            header="Zapisywanie zawodnika nie powiodło się"
                            error={this.props.savingParticipantError}/>
                <ErrorModal open={this.props.deletingParticipantFailed}
                            onClose={(e) => {
                                this.onCloseErrorModal(e)
                            }}
                            header="Usuwanie zawodnika nie powiodło się"
                            error={this.props.deletingParticipantError}/>
                <Header as="h3" attached="top">
                    <Icon name="users"/>
                    <Header.Content>Zawodnicy</Header.Content>
                </Header>
                <Table attached="bottom" basic>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell width={3}>Imię</Table.HeaderCell>
                            <Table.HeaderCell width={4}>Nazwisko</Table.HeaderCell>
                            <Table.HeaderCell width={3}>Data urodzenia</Table.HeaderCell>
                            <Table.HeaderCell width={3}>Płeć</Table.HeaderCell>
                            <Table.HeaderCell width={3} textAlign="right">
                                <Button
                                    positive
                                    icon
                                    disabled={this.props.loadingParticipants || this.props.savingParticipant || this.props.deletingParticipant || this.props.participantIndex > -1}
                                    onClick={(e) => {
                                        this.onClickAdd(e)
                                    }}><Icon name='add'/></Button>
                                <Button
                                    secondary
                                    icon
                                    loading={this.props.loadingParticipants}
                                    disabled={this.props.loadingParticipants || this.props.savingParticipant || this.props.deletingParticipant || this.props.participantIndex > -1}
                                    onClick={(e) => {
                                        this.onClickRefresh(e)
                                    }}><Icon name='refresh'/></Button>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.loadingParticipants && <Table.Row><Table.Cell colSpan='5' textAlign="center">
                            <br/><br/><Loader inline active/><br/><br/>
                        </Table.Cell></Table.Row>}
                        {!this.props.loadingParticipants && this.props.loadingParticipantsFailed && <Table.Row>
                            <Table.Cell colSpan='5' textAlign="center" style={{color: "#9f3a38"}}>
                                <Icon name='exclamation triangle'/> {this.props.loadingParticipantsError}
                            </Table.Cell>
                        </Table.Row>}
                        {!this.props.loadingParticipants && !this.props.loadingParticipantsFailed && this.props.participants.length === 0 &&
                        <Table.Row>
                            <Table.Cell colSpan='5' textAlign="center">
                                Lista zawodników jest pusta.
                            </Table.Cell>
                        </Table.Row>}
                        {!this.props.loadingParticipants && !this.props.loadingParticipantsFailed && this.props.participants.length > 0
                        && this.props.participants.map((participant, index) => this.props.participantIndex === index ?
                            <Table.Row key={index} verticalAlign="top">
                                <Table.Cell>
                                    <TextField
                                        placeholder="Imię"
                                        value={this.props.participantFirstName}
                                        disabled={this.props.savingParticipant}
                                        error={this.props.participantErrorsVisible && this.props.participantFirstNameErrors.length > 0}
                                        showErrors={this.props.participantErrorsVisible}
                                        errors={this.props.participantFirstNameErrors}
                                        onChange={(e) => {
                                            this.onChangeFirstName(e)
                                        }}/>
                                </Table.Cell>
                                <Table.Cell>
                                    <Input
                                        fluid
                                        placeholder="Nazwisko"
                                        error={this.props.participantErrorsVisible && this.props.participantLastNameErrors.length > 0}
                                        value={this.props.participantLastName}
                                        disabled={this.props.savingParticipant}
                                        onChange={(e) => {
                                            this.onChangeLastName(e)
                                        }}/>
                                    {this.props.participantErrorsVisible &&
                                    <List style={{color: "#9f3a38", margin: ".28571429rem 0 0 0"}}>
                                        {this.props.participantLastNameErrors.map((error, index) => <List.Item
                                            key={index}>{error}</List.Item>)}
                                    </List>}
                                </Table.Cell>
                                <Table.Cell>
                                    <Input
                                        fluid
                                        placeholder="Data urodzenia"
                                        error={this.props.participantErrorsVisible && this.props.participantBirthDateErrors.length > 0}
                                        value={this.props.participantBirthDate}
                                        disabled={this.props.savingParticipant}
                                        onChange={(e) => {
                                            this.onChangeBirthDate(e)
                                        }}/>
                                    {this.props.participantErrorsVisible &&
                                    <List style={{color: "#9f3a38", margin: ".28571429rem 0 0 0"}}>
                                        {this.props.participantBirthDateErrors.map((error, index) => <List.Item
                                            key={index}>{error}</List.Item>)}
                                    </List>}
                                </Table.Cell>
                                <Table.Cell>
                                    <Dropdown
                                        fluid
                                        selection
                                        placeholder='Płeć'
                                        options={[{text: 'Mężczyzna', value: 'MALE'}, {
                                            text: 'Kobieta',
                                            value: 'FEMALE'
                                        }]}
                                        value={this.props.participantGender}
                                        disabled={this.props.savingParticipant}
                                        onChange={(e, data) => {
                                            this.onChangeGender(e, data)
                                        }}/>
                                </Table.Cell>
                                <Table.Cell textAlign="right">
                                    <Button
                                        positive
                                        icon
                                        disabled={this.props.savingParticipant || (this.props.participantErrorsVisible
                                            && (this.props.participantFirstNameErrors.length > 0
                                                || this.props.participantLastNameErrors.length > 0
                                                || this.props.participantGenderErrors.length > 0
                                            ))}
                                        loading={this.props.savingParticipant}
                                        onClick={(e) => {
                                            this.onClickSave(e)
                                        }}>
                                        <Icon name='save outline'/>
                                    </Button>
                                    <Button
                                        icon
                                        disabled={this.props.savingParticipant}
                                        onClick={(e) => {
                                            this.onClickCancel(e)
                                        }}>
                                        <Icon name='cancel'/>
                                    </Button>
                                </Table.Cell>
                            </Table.Row> : <Table.Row key={index}>
                                <Table.Cell>{participant.firstName}</Table.Cell>
                                <Table.Cell>{participant.lastName}</Table.Cell>
                                <Table.Cell>{participant.birthDate}</Table.Cell>
                                <Table.Cell>{participant.gender === "MALE" && "Mężczyzna"}{participant.gender === "FEMALE" && "Kobieta"}</Table.Cell>
                                <Table.Cell textAlign="right">
                                    <Button
                                        primary
                                        icon
                                        disabled={this.props.participantIndex > -1 || this.props.deletingParticipant}
                                        onClick={(e) => {
                                            this.onClickEdit(e, participant, index)
                                        }}>
                                        <Icon name='edit'/>
                                    </Button>
                                    <Button
                                        negative
                                        icon
                                        disabled={this.props.participantIndex > -1 || this.props.deletingParticipant}
                                        loading={this.props.deletingParticipant && this.props.participantId === participant.id}
                                        onClick={(e) => {
                                            this.onClickDelete(e, participant)
                                        }}>
                                        <Icon name='trash alternate'/>
                                    </Button>
                                </Table.Cell>
                            </Table.Row>)}
                    </Table.Body>
                </Table>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        participants: state.participants.participants,
        loadingParticipants: state.participants.loadingParticipants,
        loadingParticipantsFailed: state.participants.loadingParticipantsFailed,
        loadingParticipantsError: state.participants.loadingParticipantsError,
        participantIndex: state.participants.participantIndex,
        participantId: state.participants.participantId,
        participantFirstName: state.participants.participantFirstName,
        participantFirstNameErrors: state.participants.participantFirstNameErrors,
        participantLastName: state.participants.participantLastName,
        participantLastNameErrors: state.participants.participantLastNameErrors,
        participantBirthDate: state.participants.participantBirthDate,
        participantBirthDateErrors: state.participants.participantBirthDateErrors,
        participantGender: state.participants.participantGender,
        participantGenderErrors: state.participants.participantGenderErrors,
        participantErrorsVisible: state.participants.participantErrorsVisible,
        savingParticipant: state.participants.savingParticipant,
        savingParticipantFailed: state.participants.savingParticipantFailed,
        savingParticipantError: state.participants.savingParticipantError,
        deletingParticipant: state.participants.deletingParticipant,
        deletingParticipantFailed: state.participants.deletingParticipantFailed,
        deletingParticipantError: state.participants.deletingParticipantError
    }
}

export default connect(mapStateToProps)(Participants)



// WEBPACK FOOTER //
// ./src/components/routes/Participants.js